import React from 'react';

import TagCheckbox from '$partials/fields/tag-checkbox';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/filters/individual.d.ts').MultiSelectCloud}
 */
export const MultiSelectCloud = ({
    label,
    name,
    toggleValue,
    options = [],
    value,
}) => {
    return (
        <fieldset>
            {label &&
                <legend className='block mb-16 type-style-eyebrow'>
                    {label}
                </legend>
            }

            <div className='flex flex-row flex-wrap gap-6'>
                {options?.map((option, i) => {
                    const isChecked = Boolean(value.find((v) => v === option.value));

                    return (
                        <TagCheckbox
                            checked={isChecked}
                            disabled={option.disabled}
                            id={`${name}-${option.value}`}
                            key={`${option.value}-${i}`}
                            label={option.label}
                            name={`${name}-${option.value}`}
                            onChange={() => {
                                if (typeof toggleValue === 'function') {
                                    toggleValue(option.value);
                                }
                            }}
                            value={option.value} />
                    );
                })}
            </div>
        </fieldset>
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default MultiSelectCloud;
